import { render, staticRenderFns } from "./LengthWise.vue?vue&type=template&id=c405ab4a&scoped=true"
import script from "./LengthWise.vue?vue&type=script&lang=js"
export * from "./LengthWise.vue?vue&type=script&lang=js"
import style0 from "./LengthWise.vue?vue&type=style&index=0&id=c405ab4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405ab4a",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
